/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import VisibilityIcon from "@mui/icons-material/Visibility";
import * as MODALS from '../modals';
import { openlightbox } from '../../util/Functions';
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';
import { AccountStatement, Factor } from "../modals";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles5 } from "../../util/TableStyles"
import { Paper } from "@mui/material";
import { useStyles } from "../../util/ComponentStyles";
import { noDataComponent } from "../../util/DataObject"

const ListStatement = (props) => {
    const [data, setData] = useState([]);
    const [column, setColumn] = useState([]);
    const [columns, setColumns] = useState([]);
    const history = useHistory()
    const clasess = useStyles();

    useEffect(() => {
        init();
    }, [props.content]);

    const init = async () => {
        setData(JSON.parse(JSON.stringify(props.content.data)));
        let c = [];
        c.push({
            sortable: true,
            maxWidth: "30px",
            cell: (item, index) => {
                return <div>
                    <a
                        href="#"
                        data-tag="allowRowEvents"
                        onClick={click.bind(this, item)}
                    >
                        <VisibilityIcon />
                    </a>
                </div>
            },
        })

        if(props.config.columns){
            let cols = props.config.columns;
            for(let i = 0; i<cols.length; i++){
                let col = {
                    selector: (row) => row[cols[i]['key']], 
                    name: cols[i]['label'], 
                    sortable: true,
                    maxWidth: '',
                    cell: ''
                }
                c.push(col);
            }
        }

        setColumns(c);
        if(props.content.data.length == 1){
            await click(props.content.data[0])
        }
    }

    const click = async (item) => {
        props.updateValueSearch(item.email);
        props.changeLoader(true);
        let data = {
            customerUuid: item.uuid,
        }

        let action = '';
        if(props.config.hasOwnProperty('openModal')){
            action = props.config.openModal;
            data['nextAction'] = props.config.openModal;
        }
        let request = await API.service(action, data, props.pos, props.changeAlert, props.changeLoader, history);
        if(request.status == 200 && request.data.data.response == 'OK' && request.data.data.content){
            if(request.data.data.content.type == '2FA' || request.data.data.content.type == '1FA'){
                let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
                factors[item.uuid] = request.data.data.content.uuid_factor;
                localStorage.factors = JSON.stringify(factors);
            }
            const as = <Factor
                intent={props.config.openModal}
                contentModal={request.data.data.content}
                pos={props.pos}
                changeAlert={props.changeAlert}
                changeLoader={props.changeLoader}
                history={history}
                key="factor"
            />
            openlightbox(as);
        }
        if (request.status == 200 && request.data.data.response == 'OK') {
            let widg = [];
            widg = request.data.data.widget;
            //filterSet();
            if (widg[0]?.type === 'estadoCuenta' && widg[0]?.data?.content) {
                const as = <AccountStatement dataCustomer={widg[0]?.data?.content} spaces={widg[0]?.data?.spaces}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    config={ widg[0]?.config}
                    key="accountStatement" />
                openlightbox(as);
            }
        }

        props.changeLoader(false);
    };

    return (
        <Paper className={clasess.limitsDetail}>
            <ThemeProvider theme={theme}> 
                <DataTable columns={columns} data={data} customStyles={customStyles5} noDataComponent={noDataComponent}/>
            </ThemeProvider>
        </Paper>
    )
};

export default ListStatement;
